import { render, staticRenderFns } from "./SharedLoginButtons.vue?vue&type=template&id=323adfd8&scoped=true&"
import script from "./SharedLoginButtons.vue?vue&type=script&lang=js&"
export * from "./SharedLoginButtons.vue?vue&type=script&lang=js&"
import style0 from "./SharedLoginButtons.vue?vue&type=style&index=0&id=323adfd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323adfd8",
  null
  
)

export default component.exports